<mat-nav-list vertical="bottom" horizontal="end" >
  @if(!queryDisabled()){
  <a href="" mat-list-item (click)="doQuery($event)" >
    <span matListItemTitle>查詢</span>
    <span matLine></span>
  </a>
  }
  @if(!insertDisabled()){
  <a href="" mat-list-item (click)="doInsert($event)">
    <mat-icon>insert</mat-icon><span matListItemTitle>新增</span>
    <span matLine></span>
  </a>
  }
  @if(!refreshDisabled()){
  <a href="" mat-list-item (click)="doQuery($event)">
    <mat-icon>add</mat-icon><span matListItemTitle>重新整理</span>
    <span matLine></span>
  </a>
}
  @if(!backDisabled()){
  <a href="" mat-list-item (click)="doBack()">
    <mat-icon>refresh</mat-icon><span matListItemTitle>>回上頁</span>
    <span matLine></span>
  </a>
}
  @if(!scrollTopDisabled()){
  <a href="" mat-list-item (click)="doScrollTop()">
    <mat-icon>top</mat-icon><span matListItemTitle>>頂端</span>
    <span matLine></span>
  </a>
}
</mat-nav-list>

<!-- <ion-fab-button (click)="doEdit($event)" [disabled]="editDisabled">
  <ion-icon name="create">修改</ion-icon>
</ion-fab-button>
<ion-fab-button (click)="doDelete($event)" [disabled]="deleteDisabled">
  <ion-icon name="trash">刪除</ion-icon>
</ion-fab-button> -->
